export enum TRANSFER_GROUP {
  SENT = 'sent',
  RECEIVED = 'received',
}
